// extracted by mini-css-extract-plugin
module.exports = {"container":"e_b1"};